import React from 'react';
import PropTypes from 'prop-types';

const StopWeightCell = ({ totalWeight, weightUnit }) => {
  return (
    <div>
      {totalWeight} {weightUnit}
    </div>
  );
};

StopWeightCell.propTypes = {
  totalWeight: PropTypes.number.isRequired,
  weightUnit: PropTypes.string.isRequired,
};

export default StopWeightCell;
